import { Grid, useMediaQuery, Box } from '@mui/material'
import React from 'react'
import { theme } from '../../theme/DashboardTheme'
import ScannedSites from '../shared/atom/ScannedSites'
import { useAppSelector } from '../../redux/storeExports'
import { PeopleFinderSelectors } from '@meprism/shared/src/redux/peopleFinder/PeopleFinderSlice'
import { BrokerOptOuts } from '@meprism/shared/src/redux/peopleFinder/PeopleFinderTypes'
import RemovalProgressCard from '../shared/atom/RemovalProgressCard'
import ExposureStatsCard from '../shared/atom/ExposureStatsCard'
import ScanCoverageCard from '../shared/atom/ScanCoverageCard'
import OptOutRequestsCard from '../shared/atom/OptOutRequestsCard'
import DashboardGrid from '../shared/molecule/DashboardGrid'
import PageLayout from '../layouts/PageLayout'
import MainHeader from '../shared/organism/MainHeader'
import { selectActiveGrant } from '../../redux/product/ProductSlice'
import { MpOfferHeader } from '../shared/organism/MpOfferHeader'
import { ProfileSelectors } from '@meprism/shared/src/redux/profile/ProfileSlice'

const DashboardView = () => {
  const userStats = useAppSelector(
    PeopleFinderSelectors.selectBrokerStats,
  )
  const unmatchedbrokers = useAppSelector(
    PeopleFinderSelectors.selectUnmatchedBrokers,
  )
  const optouts = useAppSelector(PeopleFinderSelectors.selectOptOuts)
  const optOutsSubmitted = optouts.filter(
    (o: BrokerOptOuts) => o.status === 'optout_submitted' || o.status === 'complete' || o.status === 'removed',
  ).length
  const pendingCount = optouts.filter(
    (o: BrokerOptOuts) => o.status === 'pending' || o.status === 'failed',
  ).length
  const grant = useAppSelector(selectActiveGrant)

  const removing = userStats?.brokers_in_progress ?? 0
  const removed = userStats?.brokers_removed ?? 0
  const profilefound = userStats?.brokers_found ?? 0
  const uniqueBrokers = userStats?.unique_brokers_exposed ?? 0
  const unmatchedBrokersCount = unmatchedbrokers.length
  const isMobile = useMediaQuery(theme.breakpoints.down('sm'))
  const user = useAppSelector(ProfileSelectors.selectProfile)

  return (
    <PageLayout>
      <MainHeader title={'Privacy Dashboard'} />
      <MpOfferHeader/>
      {!isMobile && user?.scan_completed_mail_sent_at &&  (
        <Box mb={5}>
          <ScannedSites count={''} />
        </Box>
      )}

        <Grid container columnSpacing={3} rowSpacing={5}
         sx={{
           position: 'relative',
           '@media (min-width: 1600px) and (max-width: 1681px)': {
             '& .MuiCardContent-root > .MuiBox-root:first-of-type > .MuiTypography-root': {
               fontSize: '13px',
               flexWrap: 'nowrap',
             },
             '& .MuiCardContent-root .MuiGrid-container': {
               gap: '4px',
             },
           },
           '@media (min-width: 1600px) and (max-width: 1615px)': {
             '& .MuiCardContent-root .MuiGrid-container .MuiTypography-root': {
               fontSize: '13px',
               flexWrap: 'nowrap',
               

             },
           },
         }}
        >
          <Grid item xs={12} md={6} lg={3}>
            <RemovalProgressCard
            removing={grant? removing: 0}
            removed={grant? removed: 0}
            grant={grant}
            />
          </Grid>
           <Grid item xs={12} md={6} lg={3}>
            <ExposureStatsCard profilesExposed={profilefound} brokersScanned={200} uniqueBrokersExposed={uniqueBrokers} />
          </Grid>
          <Grid item xs={12} md={6} lg={3}>
            <OptOutRequestsCard
              optOutsSubmitted={optOutsSubmitted}
              pendingCount={pendingCount}
              grant={grant}
            />
          </Grid>
          <Grid item xs={12} md={6} lg={3}>
            <ScanCoverageCard
            unmatchedBrokersCount={unmatchedBrokersCount}
            totalBrokers={200}
            />
          </Grid>
          {(!user?.scan_completed_mail_sent_at && !grant?.is_executive) && (
          <Box
            sx={{
              position: 'absolute',
              inset: 0,
              backgroundColor: 'transparent',
              backdropFilter: 'blur(4px)',
              WebkitBackdropFilter: 'blur(4px)',
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'center',
              zIndex: 10,
              borderRadius: 2,
              mt: isMobile ? 5 : 0,
            }}
          >
          </Box>
        )}
        </Grid>
      <Box mt={5}>
        <DashboardGrid />
      </Box>
    </PageLayout>
  )
}

export default DashboardView
